import React, { useState } from 'react';
import '../../styles/pages/AdminPages.css';

function AdminLogin({ onLogin }) {
  const [id, setId] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ id, password }),
      });
      const data = await response.json();
      
      if (response.ok) {
        onLogin(); // 로그인 성공
      } else {
        alert(data.message || '로그인 실패');
      }
    } catch (error) {
      console.error(error);
      alert('서버에 문제가 있습니다.');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleLogin();
    }
  };

  return (
    <div className="admin-login">
      <div className="admin-login__container">
        <h2 className="admin-login__title">관리자 로그인</h2>
        <div className="admin-login__field">
          <input
            className="admin-login__input"
            type="text"
            placeholder="아이디"
            value={id}
            onChange={(e) => setId(e.target.value)}
            onKeyDown={handleKeyDown}
          />
        </div>
        <div className="admin-login__field">
          <input
            className="admin-login__input"
            type="password"
            placeholder="비밀번호"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={handleKeyDown}
          />
        </div>
        <button className="admin-login__button" onClick={handleLogin}>로그인</button>
      </div>
    </div>
  );
}

export default AdminLogin;
